import {Tabs, TabsProps} from 'antd';
import {ReactNode} from 'react';
import style from './index.module.scss';

interface NavTabsProps extends TabsProps {
    children: ReactNode;
}

export default function NavTabs({children, ...tabProps}: NavTabsProps) {
    return (
        <div className={style.root}>
            <Tabs {...tabProps} className={style.tabs}>
                {children}
            </Tabs>
        </div>
    );
}
